<vw-toast-popup
  [isOpen]="isOpen"
  [title]="'premium.downgrade.title' | translate"
  [subtitle]="summary ? ('premium.downgrade.locked-structures' | translate) : ''"
  (close)="acknowledge()"
>
  <div class="px-4 pb-6">
    @if (summary) {
      <!-- Les espaces verrouillés, une ligne d'information chacun (cadenas). -->
      <vw-list-section class="mb-4 block" data-testid="downgrade-locked">
        @for (zone of summary.lockedZones; track zone.uid) {
          <vw-list-row [interactive]="false" [title]="zone.name">
            <vw-lock-icon vwListRowIcon class="block h-5 w-5" />
          </vw-list-row>
        }
        @for (bed of summary.lockedBeds; track bed.uid) {
          <vw-list-row [interactive]="false" [title]="bed.name" [subtitle]="bed.zoneName || ''">
            <vw-lock-icon vwListRowIcon class="block h-5 w-5" />
          </vw-list-row>
        }
      </vw-list-section>

      <p class="pb-4 text-body-s text-vw-muted">
        {{
          "premium.downgrade.limits"
            | translate
              : {
                  zones: ('common.counts.zones' | vwPlural: summary.maxZones),
                  beds: ('common.counts.beds' | vwPlural: summary.maxBedsPerZone),
                }
        }}
      </p>

      <vw-button
        look="primary"
        [label]="'premium.downgrade.cta' | translate"
        customClass="w-full"
        (click)="acknowledge(true)"
      />
      <vw-button
        look="quiet"
        [label]="'premium.downgrade.ok' | translate"
        customClass="mt-2 w-full"
        (click)="acknowledge()"
      />
    }
  </div>
</vw-toast-popup>
